export const TYPE_SHARK = 2;

export const FISHING_GAME_CONTENTS = {
  BACKGROUND: 'FISHING__GAME__BACKGROUND',
  CHARACTER: 'FISHING__GAME__CHARACTER',
  CHARACTER_FISHING: 'FISHING__GAME__CHARACTER_FISHING',
  SHARK: 'FISHING__GAME__SHARK',
  SHARK_FIN: 'FISHING__GAME__SHARK_FIN',
  FISH: 'FISHING__GAME__FISH',
  AIRPLANE: 'FISHING__GAME__AIRPLANE',
};

export const FISHING_LOADING_CONTENTS = {
  BACKGROUND: 'FISHING_LOADING_BACKGROUND',
  AIRPLANE: 'FISHING_LOADING_AIRPLANE',
};

export const additionalBetAmountChangingButtons = {
  typing: 'typing',
  plus: 'plus',
  minus: 'minus',
  min: 'min',
  max: 'max',
  allIn: 'allIn',
  multiply: 'multiply',
  divide: 'divide',
};

export const MIN_ODD = 1.2;

export const gameLayers = {
  background: 'background',
  character: 'character',
  fishPopup: 'fishPopup',
};

export const FISH_ANIMATION_NAMES = {
  Fish: 'fish',
  Shark: 'shark',
};

export const CHARACTER_ANIMATION_NAMES = {
  Idle: 'idle',
  Shark: 'sharkEnd',
  Fishing: 'fishing',
};

export const BACKGROUND_ANIMATION_NAME = 'animation';

export const SHARK_SKIN_NAME = 'shark';

export const fishingCountdownDeductionValues = {
  deductionValue: 0.1,
  intervalDelay: 100,
  precision: 1,
};

export const fishOddByIndex = [
  1, 0.5, 0, 1.2, 1.4, 1.6, 1.8, 2, 2.2, 2.4, 2.6, 2.8, 3, 3.2, 3.4, 3.6, 3.8, 4, 4.2, 4.4, 4.8, 5,
];

export const FISHING_GAME_ID = 141416;

export const DURATION_FROM_FISH = 5.5;

export const INITIAL_BET_ITEMS_FATA_FOR_MAX_PAYOUT = {
  isShowPopUp: false,
  maxPayout: null,
  freeBetId: null,
  freeBetType: null,
  currentIndex: null,
  freeBetMinOdd: null,
  isBetAccepted: false,
  betAmount: null,
  cashOutAmount: null,
  isAlreadySeenPopUp: false,
  isAutoCashOut: false,
  isHalfCashOut: false,
  halfCashOutedWinAmount: 0,
};
